import { embedDashboard } from "@superset-ui/embedded-sdk"
import "./App.css"
import Tabs from "./Components/TabComponent/Tabs";


function App() {

  const queryParams = new URLSearchParams(window.location.search)
  const dashboard_id = queryParams.get("dashboard_id")

  return (
    <div>
      <Tabs dashboard_id={dashboard_id} />
    </div>
  )
}

export default App
